<template>
    <div>
        <h4 style="color: red;" class="mb10">{{title}}</h4>
        <div class="oppo-content-box">
                <div v-for="(item,index) in list" :key="index">
                    <div class="title mb6 mt6">{{item.name}}</div>
                    <div class="line pl10" v-if="item.err_msg && item.err_msg.length !== 0">
                        <p v-for="(item1,index1) in item.err_msg" :key="index1">{{index1 + 1}}、{{item1}}</p>
                    </div>
                </div>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">已知晓</el-button>
        </p>
    </div>
</template>

<!-- oppo批量 错误计划提示-->
<script>

export default {
    name: "oppoErrorPlanModal",
    props:['cbs', 'title', 'list'],
    data(){
        return {
            formLoading: false
        }
    },
    mounted(){
    },
    methods:{
        submitModal(){
            this.cbs.confirm()
        },
        hideModal(){
            this.$emit('close');
        },
    }
}
</script>

<style lang="scss" scoped>
.oppo-content-box{
    max-height: calc(50vh);
    overflow-y: auto;
}
</style>
